import {
	GetPlayWithReturnLossReceiveRequest,
	GetPlayWithReturnLossReceiveResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerWithReturnLossReceive } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerWithReturnLossReceive(
	payload: GetPlayWithReturnLossReceiveRequest,
	props?: UseBaseQueryOptions<GetPlayWithReturnLossReceiveResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerWithReturnLossReceive, payload],
		queryFn: () => getPlayerWithReturnLossReceive(payload),
		...props,
	})
}
